import * as React from "react";
const SvgIcon50 = props => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" {...props}><path d="M0 10h18v4H-6z" style={{
    fill: "var(--accent-color,#fff)",
    stroke: "var(--accent-color,#fff)"
  }} /></svg>;
export default SvgIcon50;